"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewInvoiceRequestLink extends new_item_1.default {
    constructor(newInvoiceRequestLink) {
        super();
        this.invoiceRequestId = newInvoiceRequestLink.invoiceRequestId;
        this.expiresTime = newInvoiceRequestLink.expiresTime;
        this.url = newInvoiceRequestLink.url;
        this.expires = newInvoiceRequestLink.expires;
    }
}
exports.default = NewInvoiceRequestLink;
//# sourceMappingURL=new-invoiceRequestLink.js.map